import React from 'react';
import PropTypes from 'prop-types';

const PlanOptionPriceBlock = ({
  handleClickConfirmButton,
  enableConfirmButton,
  planOptionTotalAmount,
  totalAmountWithoutPlanOption,
}) => {

  const totalPrice = totalAmountWithoutPlanOption + planOptionTotalAmount;
  return (
    <div className="pagePlanOptionPriceBlock">
      <div className="pagePlanOptionPriceBreakdown">
        <div className="pagePlanOptionPriceItem">
          <span className="pagePlanOptionPriceItemName">基本代金（税込）</span>
          <span className="pagePlanOptionPriceItemValue">{totalAmountWithoutPlanOption.toLocaleString()}円</span>
        </div>
        <div className="pagePlanOptionPriceItem">
          <span className="pagePlanOptionPriceItemName">差額（税込）</span>
          <span className="pagePlanOptionPriceItemValue">{planOptionTotalAmount.toLocaleString()}円</span>
        </div>
        <div className="pagePlanOptionPriceItem pagePlanOptionPriceItemTotal">
          <span className="pagePlanOptionPriceItemName">旅行代金合計（税込）</span>
          <span className="pagePlanOptionPriceItemValue">{totalPrice.toLocaleString()}円</span>
        </div>
      </div>
      <div className="pagePlanOptionConfirmButton">
        <button className={`button cta ${!enableConfirmButton ? 'disabled' : ''}`} onClick={handleClickConfirmButton}>お申込内容の確認へ進む</button>
      </div>
    </div>
  ) 
};

PlanOptionPriceBlock.defaultProps = {
  handleClickConfirmButton: () => {},
  enableConfirmButton: false,
  planOptionTotalAmount: 0,
  totalAmountWithoutPlanOption: 0,
};

PlanOptionPriceBlock.propTypes = {
  handleClickConfirmButton: PropTypes.func.isRequired,
  enableConfirmButton: PropTypes.bool,
  planOptionTotalAmount: PropTypes.number,
  totalAmountWithoutPlanOption: PropTypes.number,
};

export default PlanOptionPriceBlock;